import { render, staticRenderFns } from "./IdPwLoginForms.vue?vue&type=template&id=61af56c1&"
import script from "./IdPwLoginForms.vue?vue&type=script&lang=js&"
export * from "./IdPwLoginForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports